import { Checkbox, Form, Input, Select } from 'antd'
import { FormInstance } from 'antd/es/form/Form'
import { ReusableSelector } from 'components/reusableSelector/selector'
import { renderChargerSettingText } from 'helpers/tenant-tab-render-text'
import { useGeneralTranslation } from 'hooks/translation/useGeneralTranslation'
import { useTenantTranslation } from 'hooks/translation/useTenantTranslation'
import { useSelector } from 'hooks/useSelector'
import { chargerSettings } from 'models/chargerv2'
import { ChargerSetting, Tenant } from 'models/tenant'
import { ReactElement } from 'react'
import { useAppState } from 'state'
import { theme } from 'theme'

interface TenantServiceStatusInfoProps {
  form: FormInstance<any>
  tenant: Tenant
  disabled: boolean
  currentChargerSettings: string[]
  setChargerSettings: (chargerSettings: ChargerSetting[]) => void
}

const TenantServiceStatusInfo: React.FC<TenantServiceStatusInfoProps> = ({
  form,
  tenant,
  disabled,
  currentChargerSettings,
  setChargerSettings,
}) => {
  const { isMockUpEnabled, currentUser } = useAppState()
  const { chargerSettingsText } = useTenantTranslation()
  const { adminNotesText, managerNotesText } = useGeneralTranslation()
  const { multiChargerSettingsHandlePlaceholder, multiChargerSettingsHandleChange } = useSelector()

  const renderMultiChargerSettingsOption = (
    option: string,
    selectedOptions: any[],
    handleCheckboxClick: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void,
  ): ReactElement => {
    const translateOpt = renderChargerSettingText(option)
    return (
      <Select.Option key={option} value={option} label={option}>
        <Checkbox onClick={handleCheckboxClick} checked={selectedOptions.includes(option)}>
          {translateOpt}
        </Checkbox>
      </Select.Option>
    )
  }
  return (
    <>
      {currentUser?.role === 'admin' && (
        <Form.Item
          name="chargerSetting"
          label={chargerSettingsText}
          rules={[{ required: false }]}
          className="align-center"
        >
          <ReusableSelector
            showSearch
            disabled={disabled}
            selectAllOptions
            onOptionsChange={(chargerSetting: ChargerSetting[]) => {
              setChargerSettings(chargerSetting)
              form.setFieldsValue({ chargerSetting })
            }}
            onClear={() => {
              setChargerSettings([])
              form.setFieldsValue({ chargerSetting: [] })
            }}
            isSingle={false}
            placeholder={chargerSettingsText}
            dropDownList={chargerSettings}
            showMagnifySVG={false}
            maxTagCount={0}
            isDebounceFetcher={false}
            debounceFetcher={undefined}
            defaultValues={currentChargerSettings}
            handlePlaceholder={multiChargerSettingsHandlePlaceholder}
            handleOptionChange={multiChargerSettingsHandleChange}
            renderOption={renderMultiChargerSettingsOption}
            isMockUpEnabled={isMockUpEnabled}
          />
        </Form.Item>
      )}
      {currentUser?.role === 'admin' && (
        <Form.Item name="adminNotes" label={adminNotesText}>
          <Input.TextArea disabled={disabled} showCount maxLength={255} style={{ height: theme.space[6] }} />
        </Form.Item>
      )}
      <Form.Item name="managerNotes" label={managerNotesText}>
        <Input.TextArea disabled={disabled} showCount maxLength={255} style={{ height: theme.space[6] }} />
      </Form.Item>
    </>
  )
}

export default TenantServiceStatusInfo
